import { render } from "./TotalCustomer.vue?vue&type=template&id=436f3034"
import script from "./TotalCustomer.vue?vue&type=script&lang=js"
export * from "./TotalCustomer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__